<template>
  <nav class="navigationTab">
    <ul>
      <router-link
        tag="li"
        v-for="(tab, index) in tabs"
        :key="index"
        :to="tab.url"
        replace
      >
        <a>{{ tab.name }}</a>
      </router-link>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'NavigationTab',
  components: {},
  props: {
    tabs: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss">
.navigationTab {
  position: fixed;
  top: 54px;
  left: 0;
  width: 100%;
  height: 45px;
  padding-top: 1px;
  background-color: #fff;
  border-bottom: 1px solid #a4a7b8;
  z-index: 100;
  li {
    display: inline-block;
    width: 50%;
  }
  a {
    display: inline-block;
    width: 100%;
    height: 44px;
    padding: 16px 15px 0;
    text-align: center;
    color: #3e4356;
  }
  .active a {
    position: relative;
    color: #6134f1;
    font-weight: bold;
    border-bottom: 3px solid #6134f1;
  }
}

// @media all and (min-width: 640px) {
//   .navigationTab ul {
//     width: 640px;
//     margin: 0 auto;
//   }
// }

@media screen and (min-width: 1024px) {
  .navigationTab {
    width: 1024px;
    left: 50%;
    transform: translateX(-50%);
  }
  .navigationTab ul {
    width: 1024px;
    margin: 0 auto;
  }
}
</style>
